import React, { createContext, useContext, useMemo } from 'react';

interface IRapportFontContextValue {
  defaultFont?: string;
}

const RapportFontContext = createContext<IRapportFontContextValue>({});

export const RapportFontProvider: React.FC<{
  children: React.ReactNode;
  defaultFont?: string;
}> = ({ children, defaultFont }) => {
  const contextValue: IRapportFontContextValue = useMemo(
    () => ({
      defaultFont: defaultFont,
    }),
    [defaultFont]
  );

  return (
    <RapportFontContext.Provider value={contextValue}>
      {children}
    </RapportFontContext.Provider>
  );
};

export const useRapportFont = () => {
  const context = useContext(RapportFontContext);
  return context.defaultFont;
};
